<template>
  <div class="JournalismDetail">
    <OtheHeader />
    <div class="content">
      <div class="breadcrumb">
        <img src="../assets/img/fangzi.png" alt style="width:16px;height:15px;margin-right:18px" />
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>
            <router-link to="/">
              首页
            </router-link>
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <router-link to="/Journalism">
              新闻
            </router-link>
          </el-breadcrumb-item>
          <el-breadcrumb-item>{{Detail.name}}</el-breadcrumb-item>
          <el-breadcrumb-item>正文</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="title">
        <p class="titleText">{{Detail.name}}</p>
        <p class="titleTime">{{new Date(parseInt(Detail.createtime) * 1000).toLocaleString().split(' ')[0].replace('/', '-').replace('/', '-')}}</p>
      </div>
      <div style="margin-top: 47px; margin-bottom: 60px;" v-html="Detail.content"></div>
    </div>
    <div class="nextPage">
      <router-link v-if="Detail.last" :to="{name: 'JournalismDetail', query: {id: Detail.last.id }}" target="_blank" style="display: flex;">
        <span>上一篇：{{Detail.last.name}}</span>
      </router-link>
      <a v-else href="#"><span>上一篇：没有了</span></a>
      <router-link v-if="Detail.next" :to="{name: 'JournalismDetail', query: {id: Detail.next.id }}" target="_blank" style="display: flex;">
        <span>下一篇：{{Detail.next.name}}</span>
      </router-link>
      <a v-else href="#"><span>下一篇：没有了</span></a>
    </div>
    <Footer />
  </div>
</template>

<script>
import OtheHeader from "@/components/OtheHeader.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "JournalismDetail",
  components: {
    OtheHeader,
    Footer
  },
  data() {
    return {
      Detail: {
        last: {},
        next: {}
      }
    };
  },
  created() {
    this.DetailFn();
  },
  methods: {
    DetailFn() {
      this.fetchGet("index/getNews", {
        id: this.$route.query.id
      })
        .then(res => {
          this.Detail = res.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
<style scoped lang="less">
.JournalismDetail {
  .nextPage {
    width: 100%;
    display: flex;
    height: 120px;
    line-height: 120px;
    background-color: #00A8EB;
    a {
      display: inline-block;
      width: 50%;
      padding: 0 53px;
      color: #ffffff;
      font-size: 16px;
    }
    a:first-child {
      text-align: right;
      border-right: 1px solid #ffffff;
      span {
        display: inline-block;
        width: 100%;
        text-align: right;
      }
    }
  }
  .content {
    width: 1197px;
    margin: 0 auto;
    .breadcrumb {
      display: flex;
      margin-top: 30px;
      margin-bottom: 34px;
    }
    .titleText {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 28px;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
      text-align: center;
    }
    .titleTime {
      margin-top: 32px;
      // width: 90px;
      height: 35px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 28px;
      color: rgba(204, 204, 204, 1);
      opacity: 1;
      border-bottom: 1px solid #CCCCCC;
    }
  }
}
</style>
